import React, { Component } from "react";
import { connect } from "react-redux";

import { toggleStep } from "../../../../store/actions/multiplos-actions";
import {
  Container,
  Header,
  Left,
  BackButton,
  Title,
  CloseIcon,
  SuccessContainer,
  ErrorIconContainer,
  ErrorIcon,
  SuccessTitle,
  SuccessText,
  UacContainer,
  UacItem,
  UacDescription,
  UacPhone,
  OpeningHoursContainer,
  OpeningHours
} from "../styles";

class Erro extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false
    };
  }

  render() {
    const { close, back } = this.props;
    return (
      <Container>
        <Header>
          <Left>
            {back ? (
              <BackButton
                title="Fechar"
                className="mdi mdi-arrow-left"
                onClick={() => this.props.dispatch(toggleStep(1))}
              />
            ) : null}
            <Title />
            <br />
            <br />
          </Left>
          <CloseIcon title="Fechar" className="mdi mdi-close" onClick={close} />
        </Header>
        <SuccessContainer>
          <ErrorIconContainer>
            <ErrorIcon className="mdi mdi-close-circle" />
          </ErrorIconContainer>
          <SuccessTitle>Não foi possível vincular o contrato!</SuccessTitle>
          <SuccessText>
            Tente novamente ou entre em contato com a Unidade de Apoio ao
            Cliente
          </SuccessText>
          <UacContainer>
            <UacItem>
              <UacDescription>Regiões Metropolitanas:</UacDescription>
              <UacPhone>4003 - 1616</UacPhone>
            </UacItem>
            <UacItem>
              <UacDescription>Demais Regiões:</UacDescription>
              <UacPhone>0800 - 886 - 1616</UacPhone>
            </UacItem>
          </UacContainer>
          <OpeningHoursContainer>
            <UacDescription>Horário de Atendimento:</UacDescription>
            <OpeningHours>Segunda a sábado das 07h às 18h:</OpeningHours>
          </OpeningHoursContainer>
        </SuccessContainer>
      </Container>
    );
  }
}

export default connect()(Erro);
